import styled from 'styled-components';
import { Title as Tit } from '../styled';
export { Wrapper, Title, TwoColumn } from '../styled';

export const Subtitle = styled(Tit)`
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fonts.font_regular};
`;
